import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Lock from '@material-ui/icons/Lock';
// import classNames from 'classnames';
import Avatar from '@material-ui/core/Avatar';
import Panel from '../../../components/Panel';
import ApiResponseServices from '../../../components/ApiResponseServices';
import ApiResponseData from '../../../components/ApiResponseData';

const styles = () => ({
  title: {
    display: 'block',
  },
  intervalTimeWrapper: {
    position: 'absolute',
    color: '#333',
    fontWeight: '400',
    fontSize: '14px',
    top: 0,
    right: 0,
    margin: 0,
    flexFlow: 'column',
    lineHeight: '1.25',
    padding: '6px 23px',
    cursor: 'pointer',
  },
  healthTimeAgo: {
    display: 'block',
  },
  active: {
    color: '#1682bc',
    '&:hover': {
      backgroundColor: '#ddd',
    },
  },
});

const timeAgoConfig = [
  {
    label: '24 Hours',
    value: 'day',
  },
  {
    label: '72 Hours',
    value: 'three_day',
  },
  {
    label: '7 days',
    value: 'week',
  },
];

class ApiResponseContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { timeAgo: timeAgoConfig[0], service: 'hap_notification_manager' };
    this.handleTimeAgo = this.handleTimeAgo.bind(this);
    // this.buttonClickHandler = this.buttonClickHandler.bind(this);
  }

  buttonClickHandler = (event) => {
    this.setState({ service: event.target.id });
  }

  handleTimeAgo(timeAgo) {
    this.setState({ timeAgo });
  }

  render() {
    const { classes } = this.props;
    const { active } = classes;
    const intervalTime = (
      <div className={classes.intervalTimeWrapper}>
        {
          timeAgoConfig.map(item => <div key={item.label} className={(this.state.timeAgo.label === item.label) ? classes.active : ''} onClick={() => this.handleTimeAgo(item)}>{item.label}</div>)
        }
      </div>
    );

    return (
      <div>
        <Panel
          id="apiResponseTimesPanel"
          title={(
            <div>
              API Response Times <span>{intervalTime}</span>
            </div>
          )}
          classes={{ title: classes.title }}
          avatar={<Avatar><Lock /></Avatar>}
        >
          <ApiResponseServices click={this.buttonClickHandler} />
          <ApiResponseData server={this.state.service} time={this.state.timeAgo.value} />
        </Panel>
      </div>
    );
  }
}


export default withStyles(styles)(ApiResponseContainer);
